import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const INTAKE_URL_VALIDATION_ERROR_MSG =
  "Intake URL should have the form `https://http-intake.logs.<site>` (e.g. https://http-intake.logs.datadoghq.com)";

export const DatadogComponents = InstallSpec({
  "audit-log": ItemComponent({
    type: "string",
    label: "Logs intake",
    description:
      "Allows P0 to send access events and security findings to Datadog Logs",
    maturity: "beta",
    validator: async (_context: any, id: string) => {
      if (id.indexOf(".") != -1) return "`.` is not allowed in the identifier";
    },
    schema: {
      endpoint: Element({
        label: "Intake URL",
        type: "string",
        description:
          "Datadog Logs intake URL (e.g. https://http-intake.logs.datadoghq.com for US1, https://http-intake.logs.datadoghq.eu for EU)",
        validator: async (_id, field) => {
          try {
            if (!field) return INTAKE_URL_VALIDATION_ERROR_MSG;
            const url = new URL(field);
            if (url.protocol !== "https:") {
              return INTAKE_URL_VALIDATION_ERROR_MSG;
            }
          } catch {
            return INTAKE_URL_VALIDATION_ERROR_MSG;
          }
        },
      }),
      apiKey: Element({
        label: "API key",
        type: "encrypted",
        validator: async (_id, field) => {
          if (!field?.clearText?.trim()) return "Valid API key is required";
          return undefined;
        },
      }),
      service: Element({
        label: "Service",
        type: "string",
        description:
          "Service name for log attribution (optional). Defaults to 'p0'.",
      }),
    },
    maxItems: 1,
  }),
});
